export { default } from "./useLazyGetPolls";
